export const lazyLoadDataLayer = () => {
  if (typeof window === 'undefined') {
    return
  }

  return window.dataLayer || (window.dataLayer = [])
}
